import Avatar from "@/atoms-react/avatar/Avatar.react";
import { Base } from "@/atoms-react/text/Text.react";
import { type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

type AccountSelectorProps = { smallVersion: boolean; isAdmin?: boolean };

export const AccountSelector = ({ smallVersion, isAdmin }: AccountSelectorProps) => {
  const { t } = useTranslation(["atoms"]);

  const user = JSON.parse(sessionStorage.getItem("user") ?? "");
  const fullName = user?.name;

  // This will make sure we get back to personal account when we exist companies ready pages
  // Fixme: When all pages are ready, we can remove this or replace it by something more eleganto

  return (
    <div className={twMerge("group w-full", smallVersion ? "" : "flex")}>
      <AccountSelectorCard
        title={fullName}
        description={t("account_selector.personal_account")}
        pro={false}
        smallVersion={smallVersion}
        avatar={undefined}
        isAdmin={isAdmin}
      />
    </div>
  );
};

const AccountSelectorCard = ({
  title,
  avatar,
  smallVersion,
  isAdmin
}: {
  pro?: boolean;
  title: string;
  description: string | ReactNode;
  avatar?: string | null;
  smallVersion?: boolean;
  selectable?: boolean;
  isAdmin?: boolean;
}) => {
  const { t } = useTranslation(["pass"]);

  return (
    <div className={twMerge("flex w-full grow items-center justify-center")}>
      <div
        className={twMerge(
          "relative flex h-12 w-12 shrink-0 items-center justify-center",
          "rounded-full border-2 border-primary"
        )}
      >
        <Avatar size={10} src={avatar ?? undefined} fallback={title} />
      </div>
      <div
        className={twMerge(
          "ml-3 grow overflow-hidden overflow-hidden opacity-100 transition-all",
          smallVersion && "ml-0 opacity-0"
        )}
      >
        <Base className="-mb-1 w-full overflow-hidden text-ellipsis whitespace-nowrap font-semibold">
          {title}
        </Base>
        {isAdmin && <Base className="text-sm">{t("admin_page.operator")}</Base>}
      </div>
    </div>
  );
};
